module.exports = __webpack_public_path__ + "static/media/nid_d_oiseau.506a8142.jpg";